<template>
  <div class="consultation">

    <div class="comfirmModal" v-show="isComfirm"></div>
    <div class="box" v-show="isComfirm">
      <p class="title">提示</p>
      <p class="tips">确认{{toastTitle}}?</p>
      <div class="content">
        <span @click="isComfirm = false">取消</span>
        <a id="comfirmBtn1" target="_self" href="javascript:void(0);">确认</a>
      </div>
    </div>

    <div class="release" @click="release">发 布</div>
    <a href="#" id="consultaionBtn" style="display:none" target="_blank">111</a>
    <!-- 顶部导航 -->
    <mt-navbar v-model="selected">
      <mt-tab-item id="新申请">新申请</mt-tab-item>
      <mt-tab-item id="等待中">等待中</mt-tab-item>
      <mt-tab-item id="进行中">进行中</mt-tab-item>
      <mt-tab-item id="已结束">已结束</mt-tab-item>
    </mt-navbar>
    <!-- 搜索框 -->
    <div class="search-cancel">
      <input type="text" placeholder="搜索" class="input" v-model="keyword" @keyup.enter="handleKeyUp()">
      <mt-button @click="cancel" type="primary" size="small">取消</mt-button>
    </div>
    <!-- 顶部导航对应的内容 -->
    <div v-show="selected==='等待中'" class="content-container">
        <!-- 首次进来加载动画 -->
      <div style="text-align:center;margin-top:0%;" v-if="loadmodal">
        <mt-spinner color="#26a2ff" type="triple-bounce" class="loading-more" :size="30" style="display:inline-block"></mt-spinner>
      </div>
      <div class="item-wrapper" 
        v-infinite-scroll="loadMore"
        :infinite-scroll-disabled="isMoreLoading"
        infinite-scroll-distance="5"
        :infinite-scroll-immediate-check="true"
        v-if="applyList.length > 0"
      >
        <div class="item" v-for="(item, index) in applyList" :key="index">
          <h4>{{item.name}}</h4>
          <div class="hname-doctor">
            <p class="hospital-name">{{item.diagnosisHospital}}</p>
            <p class="doctor">{{item.diagnosisDoctor}}</p>
          </div>
          <div class="hname-doctor">
            <p class="hospital-name">{{item.diagnosisDate}}</p>
            <!-- <p class="doctor">每周</p> -->
          </div>
          <div class="introduction">
          {{item.illnessRemark}}
          </div>
          <div class="waite-btn-wrapper">
            <div v-for="(subItem) in item.operation" :key="subItem">
              <mt-button @click="cancell(item)" type="primary" size="small" class="waite-btn" v-if="subItem == '取消'">取消</mt-button>
              <mt-button @click="join(item)" type="primary" size="small" class="waite-btn" v-if="subItem == '进入'">进入</mt-button>
              <mt-button @click="handleConsultation(item)" type="primary" size="small" class="waite-btn" v-if="subItem == '会诊'">会诊</mt-button>
            </div>
          </div>
        </div>
        <div style="text-align:center;margin-top:0%;" v-if="isLoading">
          <mt-spinner color="#26a2ff" type="triple-bounce" class="loading-more" :size="30" style="display:inline-block"></mt-spinner>
        </div>
        <div v-if="noMore" style="font-size:14px;text-align:center">别拉了,没有啦~</div>
      </div>
      <div v-if="notdata" style="font-size:14px;text-align:center;">
        暂无数据
      </div>
    </div>
    <div v-show="selected==='新申请'" class="content-container">
      <!-- 首次进来加载动画 -->
      <div style="text-align:center;margin-top:0%;" v-if="loadmodal">
        <mt-spinner color="#26a2ff" type="triple-bounce" class="loading-more" :size="30" style="display:inline-block"></mt-spinner>
      </div>
      <div class="item-wrapper" 
        v-infinite-scroll="loadMore"
        :infinite-scroll-disabled="isMoreLoading"
        infinite-scroll-distance="5"
        :infinite-scroll-immediate-check="true"
        v-if="applyList.length > 0"
      >
        <div class="item" v-for="(item, index) in applyList" :key="index">
          <h4>{{item.name}}</h4>
          <div class="hname-doctor">
            <p class="hospital-name">{{item.diagnosisHospital}}</p>
            <p class="doctor">{{item.diagnosisDoctor}}</p>
          </div>
          <div class="hname-doctor">
            <p class="hospital-name">{{item.diagnosisDate}}</p>
            <!-- <p class="doctor">每周</p> -->
          </div>
          <div class="introduction">
          {{item.illnessRemark}}
          </div>
          <div class="waite-btn-wrapper">
            <div v-for="(subItem) in item.operation" :key="subItem">
              <mt-button @click="edit(item)" type="primary" size="small" class="waite-btn" v-if="subItem == '编辑'">编辑</mt-button>
              <mt-button @click="arrange(item)" type="primary" size="small" class="waite-btn" v-if="subItem == '安排'">安排</mt-button>
              <mt-button @click="abolish(item)" type="primary" size="small" class="waite-btn" v-if="subItem == '作废'">作废</mt-button>
            </div>
          </div>
        </div>
        <div style="text-align:center;margin-top:0%;" v-if="isLoading">
          <mt-spinner color="#26a2ff" type="triple-bounce" class="loading-more" :size="30" style="display:inline-block"></mt-spinner>
        </div>
        <div v-if="noMore" style="font-size:14px;text-align:center">别拉了,没有啦~</div>
      </div>
      <div v-if="notdata" style="font-size:14px;text-align:center;">
        暂无数据
      </div>
    </div>     
    <div v-show="selected==='进行中'" class="content-container">
      <!-- 首次进来加载动画 -->
      <div style="text-align:center;margin-top:0%;" v-if="loadmodal">
        <mt-spinner color="#26a2ff" type="triple-bounce" class="loading-more" :size="30" style="display:inline-block"></mt-spinner>
      </div>
      <div class="item-wrapper" 
        v-infinite-scroll="loadMore"
        :infinite-scroll-disabled="isMoreLoading"
        infinite-scroll-distance="5"
        :infinite-scroll-immediate-check="true"
        v-if="applyList.length > 0"
      >
        <div class="item" v-for="(item, index) in applyList" :key="index">
          <h4>{{item.name}}</h4>
          <div class="hname-doctor">
            <p class="hospital-name">{{item.diagnosisHospital}}</p>
            <p class="doctor">{{item.diagnosisDoctor}}</p>
          </div>
          <div class="hname-doctor">
            <p class="hospital-name">{{item.diagnosisDate}}</p>
            <!-- <p class="doctor">每周</p> -->
          </div>
          <div class="introduction">
          {{item.illnessRemark}}
          </div>
          <div class="waite-btn-wrapper">
            <div v-for="(subItem) in item.operation" :key="subItem">
              <mt-button @click="handleConsultation(item)" type="primary" size="small" class="waite-btn" v-if="subItem == '会诊'">会诊</mt-button>
              <mt-button @click="join(item)" type="primary" size="small" class="waite-btn" v-if="subItem == '进入'">进入</mt-button>
              <mt-button @click="handeRecord(item)" type="primary" size="small" class="waite-btn" v-if="subItem == '记录'">记录</mt-button>
            </div>
          </div>
        </div>
        <div style="text-align:center;margin-top:0%;" v-if="isLoading">
          <mt-spinner color="#26a2ff" type="triple-bounce" class="loading-more" :size="30" style="display:inline-block"></mt-spinner>
        </div>
        <div v-if="noMore" style="font-size:14px;text-align:center">别拉了,没有啦~</div>
      </div>
      <div v-if="notdata" style="font-size:14px;text-align:center;">
        暂无数据
      </div>
    </div>
    <div v-show="selected==='已结束'" class="content-container">
      <!-- 首次进来加载动画 -->
      <div style="text-align:center;margin-top:0%;" v-if="loadmodal">
        <mt-spinner color="#26a2ff" type="triple-bounce" class="loading-more" :size="30" style="display:inline-block"></mt-spinner>
      </div>
      <div class="item-wrapper" 
        v-infinite-scroll="loadMore"
        :infinite-scroll-disabled="isMoreLoading"
        infinite-scroll-distance="5"
        :infinite-scroll-immediate-check="true"
        v-if="applyList.length > 0"
      >
        <div class="item" v-for="(item, index) in applyList" :key="index">
          <h4>{{item.name}}</h4>
          <div class="hname-doctor">
            <p class="hospital-name">{{item.diagnosisHospital}}</p>
            <p class="doctor">{{item.diagnosisDoctor}}</p>
          </div>
          <div class="hname-doctor">
            <p class="hospital-name">{{item.diagnosisDate}}</p>
          </div>
          <div class="introduction">
          {{item.illnessRemark}}
          </div>
          <div class="waite-btn-wrapper">
            <div v-for="(subItem) in item.operation" :key="subItem">
              <mt-button @click="handeRecord(item)" type="primary" size="small" class="waite-btn" v-if="subItem == '记录'">记录</mt-button>
            </div>
          </div>
        </div>
        <div style="text-align:center;margin-top:0%;" v-if="isLoading">
          <mt-spinner color="#26a2ff" type="triple-bounce" class="loading-more" :size="30" style="display:inline-block"></mt-spinner>
        </div>
        <div v-if="noMore" style="font-size:14px;text-align:center">别拉了,没有啦~</div>
      </div>
      <div v-if="notdata" style="font-size:14px;text-align:center;">
        暂无数据
      </div>
    </div>
  </div>
</template>

<script>
import { Toast } from 'mint-ui'
import { Indicator } from 'mint-ui'
import { MessageBox } from 'mint-ui';
import moment from 'moment'
export default {
  data() {
    return {
      toastTitle: '',
      keyword: '',
      status: 1,
      isLoading: false,
      notdata: false,
      noMore: false,
      isMoreLoading: false,
      loadmodal: true,
      loading: '',
      selected: '新申请',
      ops: {},
      allLoaded: false,
      applyList: [],
      pageInfo: { // 分页信息
        currentPage: 0,
        pagesize: 30,
        total: 0, // 总条数
        totalPage: 1 // 总分页数
      },
      userId: '',
      isComfirm: false
    }
  },
  created() {
    localStorage.setItem("selected", "会诊");
  },
  mounted() {
    // console.log(window.screen.height);  //屏幕高度
    // console.log(document.body.offsetHeight);  //可见区域高度
    // console.log(document.documentElement.clientHeight); //可见区域高度
    this.userId = this.GetQueryString('UserId')
    if (this.userId == null) {
      // 如果是登录进入会诊页的
      this.getAllList()
    } else {
      // 后端直接重定向到会诊页
      this.setCookie()
    }
    localStorage.setItem('selected', '会诊')
  },
  methods: {
    cancel() {
      this.pageInfo = { // 分页信息
        currentPage: 0,
        pagesize: 30,
        total: 0, // 总条数
        totalPage: 1 // 总分页数
      }
      this.isMoreLoading = false //0325解决取消没有触发自动加载更多
      this.getAllList()
      this.keyword = ''
    },
    handleKeyUp() {
      this.pageInfo = { // 分页信息
        currentPage: 0,
        pagesize: 30,
        total: 0, // 总条数
        totalPage: 1 // 总分页数
      }
      this.getAllList('', this.keyword)
    },
    // 获取浏览器地址参数
    GetQueryString(paraName) {
      let url = document.location.toString()
      let arrObj = url.split('?')
      if (arrObj.length > 1) {
        let arrPara = arrObj[1].split('&')
        let arr
        for (let i = 0; i < arrPara.length; i++) {
          arr = arrPara[i].split('=')
          if (arr != null && arr[0] == paraName) {
            return arr[1]
          }
        }
        return null
      } else {
        return null
      }
    },
    setCookie() {
      new Promise((resolve, reject) => {
        this.Axios.get('/api/WeChat/SetCookies?userID=' + this.userId).then(res => {
          if (res.data == true) {
            return resolve(true)
          }     
        })
      }).then(res => {
        if (res) {
          setTimeout(() => {
            this.getAllList()
          }, 1500)
          
          // console.log(111)
        }
      })
    },
    // 记录
    handeRecord(val) {
      this.$router.push({
        name: 'Record',
        query: {
          type: 'Record',
          rid: val.id
        }
      })
    },
    // 进入会诊
    join(val) {
      // 把会诊时间转为日期对象
      let dateObj = new Date(val.diagnosisDate)
      //把会诊时间转为时间戳
      let dateStamp = Date.parse(dateObj)
      //获取当前时间
      let currentDate = new Date()
      let currentStamp = Date.parse(currentDate)
      if (dateStamp - currentStamp > 1200000) {
        Toast({
          message: '会诊前二十分钟才能进入!',
          position: 'top',
          duration: 1500
        });
      } else {
        // let btn = document.getElementById('consultaionBtn')
        this.Axios.get("/api/LiveCourse/GetJoinUrl").then(res=>{
          const data = res.data
          if (data.status === 100) {
            let url1 = val.joinUrl + '?zpk=' + data.data
            let url = url1.replace('?', '%3f')
            url = url.replace('=', '%3d')
            // window.open(`http://plt.teleicu.cn/plt/iosToZhuMu.html?zmUrl=${url}`)
            this.toastTitle = '会诊'
            this.isComfirm = true
            let comfirmBtn = document.getElementById('comfirmBtn1')
            // // alert("苹果果机！")
            
            comfirmBtn.href = `http://plt.teleicu.cn/plt/iosToZhuMu.html?zmUrl=${url}`

            this.Axios.get('/api/Boardroom/JoinInfos?mid=' + val.id + '&type=1')
              .then(res => {
              // console.log('进入', res.data)
              })
          } else if (data.status === 200) {
            Toast({
              message: '未查询到账号信息!',
              position: 'top',
              duration: 1500
            });
          }    
        })
      }
    },
    // 点击安排按钮
    arrange(val) {
      this.$router.push({
        name: 'Arrange',
        query: {
          type: 'arrange',
          rid: val.id
        }
      })
    },
    // 点击编辑按钮
    edit(val) {
      this.$router.push({
        name: 'AddApply',
        query: {
          type: 'edit',
          rid: val.id
        }
      })
    },
    // 获取所有会诊信息
    getAllList(type, keyword) {
      this.noMore = false
      this.notdata = false
      if (type == 'loadMore') {
        this.loadmodal = false  //顶部加载动画
        this.isLoading = true //底部的加载动画
      } else {
        this.loadmodal = true
        this.isLoading = false
        this.applyList = []
      }

      if (keyword != '' || keyword != undefined) {
        var query = {
          status: this.status,
          pageindex: this.pageInfo.currentPage + 1,
          pagesize: this.pageInfo.pagesize,
          keyword: keyword
        }
      } else {
        var query = {
          status: this.status,
          pageindex: this.pageInfo.currentPage + 1,
          pagesize: this.pageInfo.pagesize
        }
      }
      
      this.Axios.get('/api/WeChat/GetConsultationInfos', {
        params: query
      }).then(res => {
        const data = res.data
        if (data.status == 100) {
          this.loadmodal = false
          // this.noMore = false
          for (let item of data.data) {
            item.diagnosisDate = moment(item.diagnosisDate).format('YYYY-MM-DD HH:mm')
            item.name = item.name + '会诊'
          }
          data.total == 0 ? this.notdata = true : this.notdata = false
          if (data.total < this.pageInfo.pagesize) {
            this.isLoading = false
            this.noMore = true
          }
          type == 'loadMore' ? this.applyList = this.applyList.concat(data.data) : this.applyList = data.data
          //总条数
          this.pageInfo.total = data.total
          //总页数
          this.pageInfo.totalPage = Math.ceil(this.pageInfo.total / this.pageInfo.pagesize)
          if (query.pageindex > this.pageInfo.totalPage) {
            this.isLoading = false
            this.noMore = true
          }
        }
      })
    },
    // 加载更多
    loadMore() {
      this.pageInfo.currentPage += 1 // 增加分页
      this.isMoreLoading = true // 是否触发加载更多
      this.isLoading = true // 加载中
      
      this.loadMore = false //顶部的加载动画
      if (this.pageInfo.currentPage > this.pageInfo.totalPage) { // 超过了分页
        this.noMore = true // 显示没有更多了
        this.isLoading = false // 关闭加载中
        return false
      }
      // 做个缓冲
      setTimeout(() => {
        this.getAllList('loadMore')
      }, 100)
    },
    // 作废会诊申请
    abolish(val) {
      MessageBox.confirm('确定作废此申请?').then(action => {
        // console.log(typeof action)
        this.Axios.put('/api/Remote/DiscardRemote?id=' + val.id).then(res => {
          const data = res.data
          if (data.status == 100) {
            Toast({
              message: '操作成功!',
              position: 'top',
              duration: 1500
            });
            this.getAllList()
          } else {
            Toast({
              message: '操作失败!',
              position: 'top',
              duration: 1500
            });
          }
        })
        .catch(error => {
          // console.log(error)
          Toast({
            message: error,
            position: 'top',
            duration: 1500
          });
        })
      });
      
    },
    // 取消会诊申请
    cancell(val) {
      MessageBox.prompt('取消理由').then(({ value, action }) => {
        this.Axios.put('/api/Remote/CancelRemote?id='+ val.id + '&cancelReason=' + value).then(res => {
          let data = res.data
          if (data.status == 100) {
            Toast({
              message: '操作成功!',
              position: 'top',
              duration: 1500
            });
            this.status = 2
            this.getAllList()
          } else {
            Toast({
              message: '操作失败!',
              position: 'top',
              duration: 1500
            });
          }
        }).catch(error => {
          console.log(error)
        })
      })
    },
    // 进行会诊
    handleConsultation(val) {
      // 把会诊时间转为日期对象
      let dateObj = new Date(val.diagnosisDate)
      //把会诊时间转为时间戳
      let dateStamp = Date.parse(dateObj)
      //获取当前时间
      let currentDate = new Date()
      //把当前时间转为时间戳
      let currentStamp = Date.parse(currentDate)
      if (dateStamp - currentStamp > 1200000) {
        Toast({
          message: '会诊前二十分钟才能开始进行会诊!',
          position: 'top',
          duration: 1500
        });
      } else {
        // let btn = document.getElementById('consultaionBtn')
        this.Axios.get("/api/LiveCourse/RefreshStartUrl?ID="+val.id+"&type=2").then(res=>{
          if(res.data.status === 100){
            let url = res.data.startUrl.replace('?', '%3f')
            url = url.replace('=', '%3d')
            // window.open(`http://plt.teleicu.cn/plt/iosToZhuMu.html?zmUrl=${url}`)
            // btn.href = res.data.startUrl
            // btn.click()
            // this.Axios.get('/api/Boardroom/JoinInfos?mid=' + val.id + '&type=1').then(res => {
            //   // console.log('进入', res.data)
            // })
            this.toastTitle = '进入'
            this.isComfirm = true
            let comfirmBtn = document.getElementById('comfirmBtn1')
            comfirmBtn.href = `http://plt.teleicu.cn/plt/iosToZhuMu.html?zmUrl=${url}`
            // alert("苹果果机！")
            this.getAllList()
          } else if (res.data.status === 200){
            Toast({
              message: '内部异常请联系管理员,或重试!',
              position: 'top',
              duration: 1500
            });
          } else {
            Toast({
              message: '参数错误!',
              position: 'top',
              duration: 1500
            });
          }
        })
      }
    },
    // 进行中
    conduct() {
      this.isMoreLoading = false //0325解决取消没有触发自动加载更多

      this.selected = '进行中'
      this.pageInfo.currentPage = 0
      this.status = 3
      this.getAllList()
    },
    // 新申请
    newApply() {
      this.isMoreLoading = false //0325解决取消没有触发自动加载更多

      this.selected = '新申请'
      this.status = 1
      this.pageInfo.currentPage = 0
      this.getAllList()
    },
    // 等待中
    waiting() {
      this.isMoreLoading = false //0325解决取消没有触发自动加载更多

      this.selected = '等待中'
      this.pageInfo.currentPage = 0
      this.status = 2
      this.getAllList()
    },
    // 已结束
    ended() {
      this.isMoreLoading = false //0325解决取消没有触发自动加载更多

      this.selected = '已结束'
      this.pageInfo.currentPage = 0
      this.status = 6
      this.getAllList()
    },
    // 发布
    release() {
      this.$router.push({
        name: 'AddApply',
        query: {
          type: 'add'
        }
      })
    }
  },
  watch: {
    selected: function(val, oldVal) {
      // console.log(val)
      if (val == '进行中') {
        this.conduct()
      } else if (val == '新申请') {
        this.newApply()
      } else if (val == '等待中') {
        this.waiting()
      } else {
        this.ended()
      }
    }
  }
}
</script>

<style lang="less">
.consultation {
  height: 100%;
  background: #f5f5f9;
  .comfirmModal {
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    opacity: .5;
    background: #000;
    z-index: 2;
  }
  .box {
    position: fixed;
    top: 50%;
    left: 50%;
    -webkit-transform: translate3d(-50%,-50%,0);
    transform: translate3d(-50%,-50%,0);
    background-color: #fff;
    width: 85%;
    border-radius: 3px;
    font-size: 16px;
    -webkit-user-select: none;
    overflow: hidden;
    -webkit-backface-visibility: hidden;
    backface-visibility: hidden;
    -webkit-transition: .2s;
    transition: .2s;
    // opacity: 1;
    z-index: 99;
    .title {
      text-align: center;
      font-weight: 700;
      font-size: 16px;
    }
    .tips {
      text-align: center;
      height: 36px;
      line-height: 36px;
      padding: 10px 20px 15px;
      color: rgb(153, 153, 153);
    }
    .content {
      height: 36px;
      line-height: 36px;
      border-top: 1px solid #ccc;
      span {
        cursor: pointer;
        display: inline-block;
        width: 50%;
        text-align: center;
        border-right: 1px solid #ccc;
        box-sizing: border-box;
      }
      a {
        cursor: pointer;
        display: inline-block;
        width: 50%;
        text-align: center;
        text-decoration: none;
        color: rgb(38, 162, 255)
      }
    }
  }
  .search-cancel {
    background: #f5f5f9;
    height: 32px;
    border-top: 1px solid #ccc;
    padding-left: 3%;
    padding-top: 10px;
    padding-bottom: 10px;
    overflow: hidden;
    width: 100%;
    .input {
      width: 67%;
      height: 30px;
      border: white;
      border-radius: 4px;
      text-align: center;
      outline: none;
    }
    .mint-button--small {
      height: 26px;
      margin-left: 4%;
    }
  }
  .release {
    position: fixed;
    right: 5%;
    top: 70%;
    z-index: 999;
    width: 20%;
    height: 50px;
    background: #66ffcc;
    text-align: center;
    line-height: 50px;
    border-radius: 10% 25%;
    color: #fff;
  }
  .mint-navbar {
    background: #f5f5f9;
    height: 48px;
  }
  .content-container {
    height: ~"calc(100% - 101px)";
    .item-wrapper {
      height: 99%;
      overflow: auto;
      .item {
        width: 92%;
        padding-left: 4%;
        padding-right: 4%;
        background: white;
        padding-top: 4%;
        padding-bottom: 1%;
        margin-bottom: 8px;
        h4 {
          margin: 0;
          margin-bottom: 15px;
        }
        .hname-doctor {
          overflow: hidden;
          font-size: 14px;
          margin-bottom: 14px;
          color: #aeaeae;
          .hospital-name {
            float: left;
            margin: 0;
          }
          .doctor {
            float: right;
            margin: 0;
          }
        }
        .introduction {
          font-size: 13px;
          margin-bottom: 14px;
          color: #aeaeae;
          line-height: 20px;
        }
        .waite-btn-wrapper {
          overflow: hidden;
          .waite-btn {
            height: 24px;
            margin-left: 2%;
            float: right;
            margin-bottom: 10px;
          }
        }
      }
    }
  }
  input::-webkit-input-placeholder, textarea::-webkit-input-placeholder, select {
    font-weight: 400 !important;
    color: rgb(102, 102, 102) !important;
    font-size: 14px !important;
    font-family: 'Franklin Gothic Medium', 'Arial Narrow', Arial, sans-serif;
  }
  input::-moz-placeholder, textarea::-moz-placeholder {
    font-weight: 400 !important;
    color: rgb(102, 102, 102) !important;
    font-size: 14px !important;
    font-family: 'Franklin Gothic Medium', 'Arial Narrow', Arial, sans-serif;
  }
  input::-ms-input-placeholder, textarea::-ms-input-placeholder {
    font-weight: 400 !important;
    color: rgb(102, 102, 102) !important;
    font-size: 14px !important;
    font-family: 'Franklin Gothic Medium', 'Arial Narrow', Arial, sans-serif;
  }
}
</style>
